import { render, staticRenderFns } from "./SecurityPage.vue?vue&type=template&id=1e76b5aa&"
import script from "./SecurityPage.vue?vue&type=script&lang=js&"
export * from "./SecurityPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\corpmessengerwebapp_rtp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e76b5aa')) {
      api.createRecord('1e76b5aa', component.options)
    } else {
      api.reload('1e76b5aa', component.options)
    }
    module.hot.accept("./SecurityPage.vue?vue&type=template&id=1e76b5aa&", function () {
      api.rerender('1e76b5aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/security/SecurityPage.vue"
export default component.exports